// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"Style_modal_body__1dapP","Modal_body_input":"Style_Modal_body_input__1Mj2C"};